import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const onboardingRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "onboarding",
}).lazy(() => import("./index.lazy").then((d) => d.Route));
